import { getId } from '../../util/data';
import { Loading } from '../../util/decorators';
import { createEmptyObject, omit } from '../../util/object';
import { apiFileUpload, apiLogoAdd, apiLogoGet, apiLogoUpdate, type Logo } from '../api';

export interface IDataSource extends Logo { }

export class LogoService {
  dataSource: IDataSource = createEmptyObject();

  dataSourceLoading = false;

  @Loading<LogoService>(['dataSourceLoading'])
  async requestDataSource() {
    const { data } = await apiLogoGet();
    this.dataSource = data[0] || { id: getId() };
  }

  @Loading<LogoService>(['dataSourceLoading'])
  async upsert(record: IDataSource, files?: { head?: null | Blob, foot?: null | Blob; }) {
    if (files) {
      if (files.head) {
        const { data } = await apiFileUpload(files.head);
        record.slogo = data;
      }
      if (files.foot) {
        const { data } = await apiFileUpload(files.foot);
        record.xlogo = data;
      }
    }
    if (record.id >= 0) {
      await apiLogoUpdate(record);
    } else {
      await apiLogoAdd(omit(record, ['id']));
    }
  }
}

export const logoService = new LogoService();
